export type Theme = "light" | "dark";
export type Density = "comfortable" | "compact";

type Tweaks = { theme: Theme; density: Density; accent: string };

const STORAGE_KEY = "pzrm_m_tweaks";
const DEFAULTS: Tweaks = { theme: "light", density: "comfortable", accent: "#b7765b" };

export function loadTweaks(): Tweaks {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULTS;
    const parsed = JSON.parse(raw) as Partial<Tweaks>;
    return { ...DEFAULTS, ...parsed };
  } catch {
    return DEFAULTS;
  }
}

export function saveTweaks(t: Tweaks): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(t));
  } catch {
    // localStorage disabled — ignore.
  }
}

export function applyTweaks(t: Tweaks): void {
  const root = document.documentElement;
  root.setAttribute("data-theme", t.theme);
  root.setAttribute("data-density", t.density);
  root.style.setProperty("--accent", t.accent);
}
